// extracted by mini-css-extract-plugin
module.exports = {"searchVerticalRecosContainer":"kC","productsContainer":"lC","searchVerticalReco":"mC","heading":"nC"};